export default __webpack_public_path__ + "images/85ae100b1716e79d5ce306df3989a460-milkstreet_logo@2x.png";